import json from './sprite.js';

export default {
    handle: 'en_SPT15-Playground',
    label: 'en_SPT15-Playground',
    json,
};
